import curry from 'lodash/fp/curry';
import eq from 'lodash/fp/eq';

export const eqIgnoreCase = curry((s1: string, s2: string): boolean => eq(s1.toLowerCase(), s2.toLowerCase()));
